let webglProbe: boolean | null = null;

/**
 * Whether this browser can run a Mapbox GL map at all. mapbox-gl v3 throws
 * from the Map constructor when WebGL is unavailable (older phones, locked
 * down desktops, some in-app browsers), which took the whole public story
 * viewer down to the error page. Probed once per page load.
 */
export function webglAvailable(): boolean {
  if (webglProbe !== null) return webglProbe;
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2") ||
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");
    webglProbe = !!gl;
  } catch {
    webglProbe = false;
  }
  return webglProbe;
}
